/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum Vakkengroep {
    NEDERLANDS = "Nederlands",
    ENGELS_FRANS_DUITS = "Engels, Frans, Duits",
    AARDRIJKSKUNDE_EN_GESCHIEDENIS = "Aardrijkskunde en Geschiedenis",
    ECONOMISCHE_VAKKEN = "Economische vakken",
    WIS_NATUUR_SCHEIKUNDE_EN_BIOLOGIE = "Wis-, Natuur-, Scheikunde en Biologie",
    GRIEKS_EN_LATIJN = "Grieks en Latijn",
    OVERIGE_VAKKEN = "Overige vakken"
}
